import React from "react";
import Meta from "./../components/Meta";
import { useRouter } from "./../util/router.js";

function NotFoundPage(props) {
  const router = useRouter();

  return (
    <>
      <Meta title="404" />
      <div
        style={{
          padding: "50px",
          width: "100%",
          textAlign: "center",
        }}
      >
        The page <code>{router.pathname}</code> could not be found
      </div>
    </>
  );
}

export default NotFoundPage;
